<template>
  <div class="menu__item" >
    <template v-if="short">
      <div
        class="menu__item-dropdown"
        :class="{
          'menu__item-dropdown_short-active': menu.showItem === item.name,
          'active-parent-item': menu.activeParentItem === item.name,
        }"
      >
        <div class="menu__item-link" @click.prevent="toggleShowModal(item.name)">
          <span class="material-icons icon-image-preview">
           {{ item.icon }}
          </span>
        </div>

        <div
          class="menu__item-dropdown_short"
          v-if="menu.showItem === item.name"
        >
          <MenuDropDown
            :item="item"
            :showItem="menu.showItem"
            :classActiveMenu="classActiveMenu"
            :showIcon="false"
          />
        </div>
      </div>
    </template>

    <template v-else>
      <MenuDropDown
        :item="item"
        :showItem="menu.showItem"
        :classActiveMenu="classActiveMenu"
        @toggleShowModal="toggleShowModal"
        :class="{
          'active-parent-item': menu.activeParentItem === item.name,
        }"
      />
    </template>
  </div>
</template>

<script>
const MenuDropDown = () => import('@components/Menu/MenuDropDown.vue')

export default {
  components: { MenuDropDown },
  props: {
    item: {
      type: Object
    },
    menu: {
      type: Object
    },
    short: {
      type: Boolean
    },
    classActiveMenu: {
      type: String
    }
  },
  methods: {
    toggleShowModal (name) {
      this.$emit('toggleShowModal', name)
    }
  }
}
</script>
